import { EventName } from '../constants';
import { createAndSendEvent } from '../jumboClient';

export const FindServiceableMerchantsModalClickEvent = (properties = {}) =>
  createAndSendEvent(
    EventName.FIND_SERVICEABLE_MERCHANTS_CLICK_EVENT,
    properties,
  );

export const CheckStoreServiceabilityInputEvent = (properties = {}) =>
  createAndSendEvent(
    EventName.CHECK_STORE_SERVICEABILITY_INPUT_EVENT,
    properties,
  );

export const UpdateCustomerLocationEvent = (properties = {}) =>
  createAndSendEvent(EventName.UPDATE_CUSTOMER_LOCATION_EVENT, properties);
